import React from 'react';
import { Header } from "../presentation/Header";
import { Footer } from '../presentation/Footer';

export const About = () => {
  return (
    <>
      <Header />
      <div className="text-[15px]">
        <div className="container mx-auto md:px-9 px-4 py-10">
          <div className="max-w-4xl mx-auto font-light text-center">
            <h1 className="text-3xl mb-6">Everyday fashion is our promise to you</h1>
            <p>When it comes to eCommerce, the design of your site plays a crucial role. It can make or break your website—leading to sales either falling flat or converting profitably. Shopify is a leading eCommerce website solution, and we have a great selection of the best performing Shopify themes to work with. Whether you need a theme for your own online store or to use for your next client website project, we have you covered.</p>
            <a href="/contact-us" className="bg-cyan-500 text-white rounded py-3 text-center px-8 mt-6 inline-block uppercase tracking-widest">Contact Us</a>
          </div>
        </div>
        <div className="grid md:grid-cols-2 grid-cols-1 mb-10 content-center items-center bg-gray-50">
          <div className="md:p-7 px-4 py-8">
            <div className="lg:pl-28 pl-0">
              <h5 className="text-xs">SINCE 2005</h5>
              <h1 className="text-3xl font-medium mb-5">The Founder</h1>
              <div className="font-light">
                <p className="mb-4">The best Shopify themes help you create a store that doesn’t just look nice, but is also effective in helping you convert more visitors into customers and meet your business goals.</p>
                <p className="mb-4">Optimal is the best Shopify themes to help you find the perfect option for your store without spending hours browsing.</p>
                <p className="mb-4">Because mobile Ecommmerce is bigger than ever, we’ll show you what each demos looks like for both desktop and mobile visitors, as well as share each sections and key features of theme.</p>
              </div>
            </div>
          </div>
            <div className="max-w-5xl">
              <div style={{ background: 'url(images/about-img.jpeg)', }} className="bg-cover bg-no-repeat lg:bg-center bg-left pb-[60%] "></div>
            </div>
        </div>
        <div className="container mx-auto md:px-9 px-4 pb-10">
          <h2 className="text-3xl mb-1 text-center">Our Story</h2>
          <p className="text-center mb-7">Est. 2005</p>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-6 font-light">
            <div>
              <p className="mb-5">To conclude, choosing the best Shopify theme that fits your objectives will help you manage your website more easily and outshine competitors. If your design doesn’t attract customers, or your customers find it’s difficult to search through the product catalog, they will turn to another website.</p>
              <p className="mb-5">There are loads of fantastic Shopify themes available on the market today. We have reviewed best sellings themes and create Optimal all-in-one Shopify theme fot your stores.</p>
              <p>Optimal, Avone, Belle, Nexgeek. These themes are the best ones for different industries like fashion, beauty & health, etc. Please note that they all offer great customizability to make changes to the website so that you can tailor them to any kind of business.</p>
            </div>
            <div>
              <p className="mb-5">When you’re looking for the best Shopify theme, Optimal has the awards to prove its features. Optimal is wonderful for visually striking brands with image-focused content. Therefore, it is most suitable for those who are running Fashion and clothing businesses.</p>
              <p className="mb-5">Similar to the Avone, Optimal is a product of We Are Underground. However, this theme has its own outstanding features that hold the key to its enviable reputation. Apparently, Underground packs Icon with many features that empowers Shopify store owners to create conclusive and particular experiences with ease.</p>
              <p>They all are open for your changes and enhancements. You can quickly create a store from one of the most wanted demos for online businesses and then customize your content from there.</p>
            </div>
          </div>

          <div className="md:flex flex-row mt-10">
            <div className="md:w-3/12 w-full">
              <h2 className="text-xl font-medium md:mb-0 mb-4">Our Vision</h2>
            </div>
            <div className="md:w-9/12 w-full font-light">
              <p>When viewing the previews for these themes, it’s a good idea to see how they look on a smartphone device by using the viewport switcher on the demo page. This enables you to experience your store as your mobile visitors will, helping you to get a better idea of whether the design will work with your products.</p>
            </div>
          </div>
        </div>
        <div className="bg-black py-12 md:px-16 px-6">
          <div className="container mx-auto text-white">
            <h2 className="text-2xl text-center mb-10">Join over 8000 Happy Buyers Worldwide</h2>
            <div className="grid md:grid-cols-3 grid-cols-1 gap-8">
              <div className="relative">
                <div className="font-light pl-6 quote">
                  <h3 className="text-[18px] font-normal mb-2">Design Quality</h3>
                  <p className="text-[18px]">I'm not usually that impressed by themes but this one has surpassed my expectations in terms of features, documentation, and support.</p>
                </div>
              </div>

              <div className="relative">
                <div className="font-light pl-6 quote">
                  <h3 className="text-[18px] font-normal mb-2">Design Quality</h3>
                  <p className="text-[18px]">I'm not usually that impressed by themes but this one has surpassed my expectations in terms of features, documentation, and support.</p>
                </div>
              </div>

              <div className="relative">
                <div className="font-light pl-6 quote">
                  <h3 className="text-[18px] font-normal mb-2">Design Quality</h3>
                  <p className="text-[18px]">I'm not usually that impressed by themes but this one has surpassed my expectations in terms of features, documentation, and support.</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}
